module.exports = "@media (min-width: 576px){\n    ::ng-deep .dashboard-detail-modal .modal-dialog {\n        width: 80% !important;\n        max-width: 100% !important;\n    }\n}\n\n.font-size-14 {\n    font-size: 14px;\n}\n\n.font-size-14 a:hover{\n    color: #007bff;\n}\n\n.font-size-14 a{\n    color: #000;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard-detail-popup/dashboard-detail-popup.component.css
// module id = ./src/app/dashboard/dashboard-detail-popup/dashboard-detail-popup.component.css
// module chunks = main